import { Outlet } from 'react-router-dom';
import DashHeader from '../Components/Dashbaord/DashHeader';
import SideBar from '../Common/SideBar';

const DashboardLayout = () => {
    return (
        <div className="min-h-screen flex flex-col">
            {/* Top navbar */}
            <DashHeader />

            {/* Below navbar: sidebar + outlet */}
            <div className="flex flex-1 min-h-0">
                {/* Sidebar */}
                <aside className="">
                    <SideBar />
                </aside>

                {/* Main content */}
                <main className=" w-full bg-gray-100 overflow-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
